import { render, staticRenderFns } from "./PriorService.vue?vue&type=template&id=5b2a18cd&"
import script from "./PriorService.vue?vue&type=script&lang=ts&"
export * from "./PriorService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2a18cd')) {
      api.createRecord('5b2a18cd', component.options)
    } else {
      api.reload('5b2a18cd', component.options)
    }
    module.hot.accept("./PriorService.vue?vue&type=template&id=5b2a18cd&", function () {
      api.rerender('5b2a18cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/PriorService.vue"
export default component.exports